"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Login = void 0;
var react_1 = __importStar(require("react"));
var Textfield_1 = require("../Inputs/Textfield/Textfield");
var globalMu_1 = __importDefault(require("../../globalMu"));
var Tooltip_1 = require("../Tooltip/Tooltip");
var Icone_1 = require("../Icone/Icone");
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var LogoMicroUniverso_1 = require("../LogoMicroUniverso/LogoMicroUniverso");
var Botao_1 = require("../Botao/Botao");
var Cores_1 = require("../Cores/Cores");
var Rodape_1 = require("../Rodape/Rodape");
var Divider_1 = require("../Divider/Divider");
var estiloLoginUsuario = require('./login.module.scss');
//#endregion
var Login = function (props) {
    //#region Variaveis
    var _a = (0, react_1.useState)(""), usuario = _a[0], setUsuario = _a[1];
    var _b = (0, react_1.useState)(""), senha = _b[0], setSenha = _b[1];
    var _c = (0, react_1.useState)(false), capsLockAtivado = _c[0], setCapsLockAtivado = _c[1];
    var _d = (0, react_1.useState)("regular"), usuarioVariante = _d[0], setUsuarioVariante = _d[1];
    var _e = (0, react_1.useState)("regular"), senhaVariante = _e[0], setSenhaVariante = _e[1];
    var _f = (0, react_1.useState)(window.innerWidth <= 1024), isMobile = _f[0], setIsMobile = _f[1];
    var validarCampos = function () {
        if (!globalMu_1.default.isNotNullOrEmpty(usuario))
            setUsuarioVariante("error");
        else if (globalMu_1.default.isNotNullOrEmpty(usuario))
            setUsuarioVariante("regular");
        if (!globalMu_1.default.isNotNullOrEmpty(senha))
            setSenhaVariante("error");
        else if (globalMu_1.default.isNotNullOrEmpty(senha))
            setSenhaVariante("regular");
    };
    //#endregion
    //#region Usuario
    var inputUsuario = react_1.default.createElement("div", { className: estiloLoginUsuario.campos },
        react_1.default.createElement("div", { className: estiloLoginUsuario.textfield },
            react_1.default.createElement(Textfield_1.Textfield, { valor: usuario, autoCompletar: "username", iconeInputField: "", titulo: "Usu\u00E1rio", placeholder: "Digite seu usu\u00E1rio...", variante: usuarioVariante, onChange: function (value) {
                    value ? setUsuario(value) : setUsuario(undefined);
                    if (value)
                        setUsuarioVariante("regular");
                }, autofocus: true })),
        react_1.default.createElement("div", { className: estiloLoginUsuario.tooltip },
            react_1.default.createElement(Tooltip_1.Tooltip, { descricaoTooltip: usuarioVariante === "error" ? "Insira seu usuário e/ou senha corretamente." : "Insira seu usuário.", estiloTooltip: usuarioVariante === "error" ? "error" : "azulMU", mostrarDivider: false },
                react_1.default.createElement(Icone_1.Icone, { nome: usuarioVariante === "error" ? "error" : "info", cor: usuarioVariante === "error" ? Cores_1.Cores.MensagensDoSistema.VermelhoMU : Cores_1.Cores.MensagensDoSistema.AzulMU, largura: "27px", altura: "27px" }))));
    //#endregion
    //#region Senha
    var inputSenha = (react_1.default.createElement("div", { className: estiloLoginUsuario.campos },
        react_1.default.createElement("div", { className: estiloLoginUsuario.textfield },
            react_1.default.createElement(Textfield_1.Textfield, { senha: true, autoCompletar: "current-password", valor: senha, iconeInputField: "", titulo: "Senha", placeholder: "Digite sua senha...", variante: senhaVariante, onChange: function (value) {
                    value ? setSenha(value) : setSenha(undefined);
                    if (value)
                        setSenhaVariante("regular");
                } })),
        react_1.default.createElement("div", { className: estiloLoginUsuario.tooltip },
            react_1.default.createElement(Tooltip_1.Tooltip, { descricaoTooltip: senhaVariante === "error" ? "Insira seu usuário/senha corretamente." : "Insira sua senha.", estiloTooltip: senhaVariante === "error" ? "error" : "azulMU", mostrarDivider: false },
                react_1.default.createElement(Icone_1.Icone, { nome: senhaVariante === "error" ? "error" : "info", cor: senhaVariante === "error" ? Cores_1.Cores.MensagensDoSistema.VermelhoMU : Cores_1.Cores.MensagensDoSistema.AzulMU, largura: "27px", altura: "27px" })))));
    //#endregion
    //#region CapsLock
    var checkCapsLock = function (event) {
        setCapsLockAtivado(event.getModifierState("CapsLock"));
    };
    var avisoCapsLockAtivado = react_1.default.createElement("div", { className: estiloLoginUsuario.capsLock }, capsLockAtivado && (react_1.default.createElement("div", { className: estiloLoginUsuario.capsLockAtivo },
        react_1.default.createElement(Icone_1.Icone, { nome: "warning", cor: Cores_1.Cores.MensagensDoSistema.LaranjaMU, largura: "30px", altura: "30px", style: { marginRight: "10px" } }),
        react_1.default.createElement(Corpo_1.Corpo, { tipo: "body1", negrito: 700, tag: "h1", cor: Cores_1.Cores.MensagensDoSistema.LaranjaMU }, "CapsLock Ativado!"))));
    //#endregion
    //#region RenderFormulario    
    var logoEsquerda = (react_1.default.createElement("div", { className: estiloLoginUsuario.logo },
        react_1.default.createElement(LogoMicroUniverso_1.LogoMicroUniverso, { tipoLogo: "largeLogoBlue", Largura: "80vw", Altura: "100%", style: {
                maxWidth: "100%",
            } })));
    var logoDireita = (react_1.default.createElement("div", { className: estiloLoginUsuario.cabecalho },
        react_1.default.createElement("div", { style: { width: '56%' } },
            react_1.default.createElement(LogoMicroUniverso_1.LogoMicroUniverso, { tipoLogo: isMobile ? "MU_Icone_Label" : "MULabelBlue_Slogan", Altura: "7rem", Largura: "100%", style: {
                    maxWidth: "100%",
                    aspectRatio: isMobile ? "3 / 1" : "16 / 9",
                    objectFit: "contain",
                } }))));
    var camposUsuarioSenha = react_1.default.createElement(react_1.default.Fragment, null,
        inputUsuario,
        inputSenha);
    var botaoAcessar = react_1.default.createElement("div", { className: estiloLoginUsuario.botao },
        react_1.default.createElement(Botao_1.Botao, { onClick: function () { return handleLogin(); }, onKeyDown: function (e) {
                if (e.key === "Enter" || e.key === "NumpadEnter") {
                    handleLogin();
                }
            } }, "Acessar"));
    var formularioLogin = react_1.default.createElement("form", { action: "", className: estiloLoginUsuario.loginForm },
        logoDireita,
        isMobile ? react_1.default.createElement(Divider_1.Divider, { orientacao: "horizontal", style: { width: '90%' } }) : null,
        react_1.default.createElement("div", { className: estiloLoginUsuario.inputs },
            camposUsuarioSenha,
            botaoAcessar),
        react_1.default.createElement("div", { className: estiloLoginUsuario.inferiorForm }, avisoCapsLockAtivado));
    //#endregion
    //#region ValidarCampos
    var handleLogin = function () {
        validarCampos();
        if (usuario && senha) {
            props.onLogin(usuario, senha);
        }
    };
    //#endregion
    //#region useEffect
    (0, react_1.useEffect)(function () {
        window.addEventListener("keydown", checkCapsLock);
        window.addEventListener("keyup", checkCapsLock);
        return function () {
            window.removeEventListener("keydown", checkCapsLock);
            window.removeEventListener("keyup", checkCapsLock);
        };
    }, []);
    //#endregion
    (0, react_1.useEffect)(function () {
        var handleResize = function () { return setIsMobile(window.innerWidth <= 1024); };
        window.addEventListener("resize", handleResize);
        return function () { return window.removeEventListener("resize", handleResize); };
    }, []);
    //#region Return
    return (react_1.default.createElement("div", { className: estiloLoginUsuario.container, style: { backgroundColor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU100 } },
        react_1.default.createElement("div", { className: estiloLoginUsuario.conteudo },
            react_1.default.createElement("div", { className: estiloLoginUsuario.conteudoEsquerda }, logoEsquerda),
            react_1.default.createElement("div", { className: estiloLoginUsuario.conteudoDireita }, formularioLogin)),
        react_1.default.createElement("div", { className: estiloLoginUsuario.rodape },
            react_1.default.createElement(Rodape_1.Rodape, { telaLogin: true, sombreado: false }))));
    //#endregion
};
exports.Login = Login;
